import {Model} from "@tailflow/laravel-orion/lib/model";

export class Source extends Model<{
    title: string,
    url: string,
}> {

    $resource(): string {
        return "module/sources";
    }
}
